// src/components/examples/IsolatedTest.js
import React from 'react';

const IsolatedTest = () => {
  console.log('🚀 IsolatedTest component loaded successfully!');
  console.log('📍 Current URL:', window.location.href);
  console.log('📍 Current Path:', window.location.pathname);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-2xl text-center">
        <div className="text-6xl mb-4">🎉</div>
        <h1 className="text-4xl font-bold text-purple-800 mb-4">
          Routing Success!
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          If you can see this page, the routing is working correctly!
        </p>
        
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-purple-800 mb-2">Debug Information:</h2>
          <div className="text-sm text-purple-700 space-y-1 text-left">
            <p><strong>URL:</strong> {window.location.href}</p>
            <p><strong>Path:</strong> {window.location.pathname}</p>
            <p><strong>Component:</strong> IsolatedTest</p>
            <p><strong>Timestamp:</strong> {new Date().toLocaleString()}</p>
          </div>
        </div>
        
        <div className="space-y-2">
          <a 
            href="/test-video-upload" 
            className="block w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
          >
            🎥 Test Video Upload
          </a>
          <a 
            href="/simple-test" 
            className="block w-full bg-green-600 text-white py-3 px-6 rounded-lg hover:bg-green-700 transition-colors"
          >
            ✅ Test Simple Route
          </a>
          <a 
            href="/" 
            className="block w-full bg-gray-600 text-white py-3 px-6 rounded-lg hover:bg-gray-700 transition-colors"
          >
            🏠 Go Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default IsolatedTest; 